// extracted by mini-css-extract-plugin
export default {"bottomNavContainer":"BottomNav_bottomNavContainer__vMXNP","navItem":"BottomNav_navItem__tJ062"};